module.exports = __webpack_public_path__ + "img/new-index-hall-swiper.c3cfe91e.png";